/* import __COLOCATED_TEMPLATE__ from './table-engagement-report-last-updated-cell.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-default-task-ember-concurrency */
/* eslint-disable @intercom/intercom/no-bare-strings */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency-decorators';
import fullRelativeTimeAgo from 'embercom/lib/full-relative-time-ago';

export default class TableComponent extends Component {
  @tracked article = null;
  @tracked lastUpdated = null;
  @tracked toolTip = null;

  constructor() {
    super(...arguments);
    this.loadLastUpdatedAndToolTip.perform();
  }

  @task
  *loadLastUpdatedAndToolTip() {
    try {
      this.article = yield this.args.data.articleCollection.get(this.args.row.groupName);
      this.lastUpdated = fullRelativeTimeAgo(this.args.data.getCellValue(this.article));
      this.toolTip = this.args.data.getCellValue(this.article);
    } catch (_e) {
      this.article = null;
      this.toolTip = null;
      this.lastUpdated = 'Unknown';
    }
  }
}
